import { FileWrapper } from '@/@diffrag/form/fields/FormFileField'
import { api } from '@/api'

type SearchApiHelperArgs = {
  searchText: string
  amount: number
  page: number
}

export const apiHelper = {
  async uploadImage(file: FileWrapper) {
    const res = await api().assets.uploadCreate({
      file: file.file,
      crop: JSON.stringify([file.crop]),
    })

    return res
  },
}

export const SearchApiHelper = {
  // subjects: async () => {
  //   const res = await api().admin.adminGetSubjects()
  //   return {
  //     rows: res,
  //     page: 1,
  //     count: res.length,
  //   }
  // },
  // smartnotes: async (args: SearchApiHelperArgs) => {
  //   return api().admin.adminGetSmartnotes(args)
  // },
  // sliceq: async (args: SearchApiHelperArgs) => {
  //   return api().admin.adminGetSliceqSet(args)
  // },
  // keywords: async (args: SearchApiHelperArgs) => {
  //   return api().admin.adminGetKeywords(args)
  // },
  // questions: async (args: SearchApiHelperArgs) => {
  //   return api().admin.adminGetQuestions(args)
  // },
  // words: async (args: SearchApiHelperArgs) => {
  //   return api().admin.adminGetWordList(args)
  // },
  // vocabulary: async (args: SearchApiHelperArgs) => {
  //   return api().admin.adminGetVocabularies(args)
  // },
  // solves: async (args: SearchApiHelperArgs) => {
  //   return api().admin.adminGetSolveList(args)
  // },
  // categories: async (args: SearchApiHelperArgs) => {
  //   return api().admin.adminGetCategoryList(args)
  // },
  // users: async (args: SearchApiHelperArgs) => {
  //   return api().admin.adminGetUserList(args)
  // },
}
